// extracted by mini-css-extract-plugin
export var container = "_fq-0";
export var segment = "_fq-2";
export var segmentActive = "_fq-3";
export var track = "_fq-1";